import ReportTypes from '@/modules/Statistics/api/models/ReportTypes';

export default class ReportTypesRepository {
    public static getAll() {
        return ReportTypes.all();
    }
}
